var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ready)?_c('div',[_c('button',{on:{"click":function($event){return _vm.saveConverted()}}},[_vm._v("Convert")]),_c('div',[_vm._v(_vm._s(_vm.nbconterted)+" / "+_vm._s(_vm.migs.length)+" -- "+_vm._s(_vm.nberrors)+" erreurs")]),(_vm.converted)?_c('div',[_vm._v("Convertion terminée")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }